import { ChevronRight } from "lucide-react";
import { WorkOrdersAdmin } from "@/components/admin/WorkOrdersAdmin";

export function WorkOrdersPage() {
  return (
    <>
      <div className="topbar">
        <div className="topbar__crumbs">
          <span>Admin</span>
          <ChevronRight size={14} />
          <strong>Work Orders</strong>
        </div>
      </div>
      <div className="page page--wide">
        <WorkOrdersAdmin />
      </div>
    </>
  );
}
